import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Button } from '@bfe/moly';
import { PhoneIcon } from '@bfe/moly-icons';
import React, { useMemo } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';
import { useI18nContext } from '@/i18n/I18n';
import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useUserStore } from '@/store/useUser';

const PhoneAuth = () => {
  const [$t, lang] = useI18nContext();
  const {
    toggleWholePhoneNumber,
    wholePhoneNumber,
    showWholePhoneNumber,
    userProfile: { userInfo: user },
  } = useUserStore();
  const { openSecuritySettingModal } = useSecuritySettingModal();

  // 打开modal弹窗
  const openSettingModal = () => {
    openSecuritySettingModal(SecuritySettingModalNames.Mobile);
  };

  const Phonebtn = useMemo(() => {
    const type = user.mobile_verified;
    if (type && type != null) {
      return 'modify';
    }
    return 'Setting';
  }, [user, lang]);

  return (
    <>
      <AccountBasicItem
        icon="mobile"
        molyIcon={<PhoneIcon />}
        text={$t('SMS Authentication')}
        subText={
          <>
            {$t(
              'For Login, password retrieval, security settings change and API management verification',
            )}
          </>
        }
        status={!!user.mobile_verified}
        statusNode={
          <>
            {user.vague_mobile ? (
              <>
                {!showWholePhoneNumber ? (
                  <>
                    <span>{user.vague_mobile}</span>
                    <EyeInvisibleOutlined onClick={toggleWholePhoneNumber} />
                  </>
                ) : (
                  <>
                    <span>{wholePhoneNumber}</span>
                    <EyeOutlined onClick={toggleWholePhoneNumber} />
                  </>
                )}
              </>
            ) : (
              <span className="not-set-text">{$t('Not Set')}</span>
            )}
          </>
        }
        operation={
          <>
            {user.mobile_verified ? (
              <Button
                size="small"
                data-radius="small"
                variant="secondary"
                onClick={() => openSettingModal()}
              >
                {$t(Phonebtn)}
              </Button>
            ) : (
              // 未设置手机验证的情况
              <Button
                size="small"
                data-radius="small"
                variant="primary"
                onClick={() => openSettingModal()}
              >
                {$t(Phonebtn)}
              </Button>
            )}
          </>
        }
      />
    </>
  );
};
export default PhoneAuth;
